import React from "react";
import "@szhsin/react-menu/dist/index.css";
import MenuItems from "./menuItem";

const SpyFilterCategory = ({ value, onChange, filterCategory = [] }) => {
    return (
        <div className="d-flex gap-3 flex-wrap">
            {filterCategory.map((menu) => (
                <MenuItems key={menu.value} menu={menu} value={value} onChange={onChange} />
            ))}
        </div>
    );
};

export default SpyFilterCategory;
